export const he = {
  header: {
    logo: 'ענבל ארט מייקרס',
    nav: {
      tutorials: 'מדריכים',
      workshops: 'סדנאות',
      shop: 'חנות',
      myOrders: 'הזמנות שלי',
      deals: 'קישורי קנייה מומלצים',
      about: 'אודות',
      contact: 'צור קשר',
      admin: 'ניהול',
      cricut: 'קריקט',
      goldsmith: 'צורפות',
      teva: 'מייקרים ויצירה מקיימת',
      modeling3d: '3D מידול',
      svgfiles: 'פריסות למיתוג וקבצי SVG',
      sublimation: 'סובלימציה',
      others: 'אחרים'
    },
    search: 'חיפוש',
    searchPlaceholder: 'חפש מדריכים, מוצרים, סדנאות...',
    cart: 'עגלת קניות',
    language: 'שנה שפה',
    login: 'התחבר',
    logout: 'התנתק'
  },
  footer: {
    about: 'אודות',
    contact: 'צור קשר',
    terms: 'תנאי שימוש',
    copyright: 'ענבל ארט מייקרס. כל הזכויות שמורות.'
  },
  auth: {
    login: 'התחבר',
    register: 'הרשם',
    email: 'אימייל',
    password: 'סיסמה',
    confirmPassword: 'אימות סיסמה',
    firstName: 'שם פרטי',
    lastName: 'שם משפחה',
    phoneNumber: 'מספר טלפון',
    phoneNumberOptional: 'אופציונלי',
    noAccount: 'אין לך חשבון?',
    alreadyHaveAccount: 'כבר יש לך חשבון?',
    loginFailed: 'ההתחברות נכשלה',
    registrationFailed: 'ההרשמה נכשלה',
    passwordsDoNotMatch: 'הסיסמאות אינן תואמות',
    passwordMinLength: 'הסיסמה חייבת להכיל לפחות 6 תווים',
    forgotPassword: 'שכחת סיסמה?',
    forgotPasswordDescription: 'הזן את כתובת האימייל שלך ואנו נשלח לך קישור לאיפוס הסיסמה.',
    sendResetLink: 'שלח קישור איפוס',
    checkEmail: 'בדוק את האימייל שלך לקישור האיפוס.',
    sendAnother: 'שלח אימייל נוסף',
    backToLogin: 'חזרה להתחברות',
    resetPassword: 'איפוס סיסמה',
    resetPasswordDescription: 'הזן את הסיסמה החדשה שלך למטה.',
    newPassword: 'סיסמה חדשה',
    invalidToken: 'טוקן לא תקין',
    invalidTokenMessage: 'קישור איפוס הסיסמה הזה לא תקין או פג תוקפו.',
    requestNewLink: 'בקש קישור חדש',
    marketingConsent: 'אני מסכים לקבל הודעות שיווקיות, אירועי הנחה והצעות פרסומיות מהאתר',
    marketingConsentOptional: 'אופציונלי - ניתן לבטל את הסימון בכל עת',
    emailVerification: 'אימות כתובת אימייל',
    emailVerificationDescription: 'אנא הזן את קוד האימות בן 5 הספרות שנשלח לכתובת האימייל שלך.',
    verificationCode: 'קוד אימות',
    sendVerificationCode: 'שלח קוד אימות',
    verifyEmail: 'אמת אימייל',
    resendCode: 'שלח קוד חדש',
    codeExpired: 'קוד האימות פג תוקפו. אנא בקש קוד חדש.',
    invalidCode: 'קוד אימות לא תקין. אנא נסה שוב.',
    emailVerified: 'האימייל אומת בהצלחה!',
    checkEmailForCode: 'אנא בדוק את האימייל שלך לקבלת קוד האימות.',
    backToRegistration: 'חזרה להרשמה',
    userAlreadyExists: 'משתמש עם כתובת אימייל זו כבר קיים. אנא נסה להתחבר במקום זאת.'
  },
    profile: {
      editProfile: 'עריכת פרופיל',
      profileInformation: 'פרטי פרופיל',
      changePassword: 'שינוי סיסמה',
      updateProfile: 'עדכן פרופיל',
      currentPassword: 'סיסמה נוכחית',
      newPassword: 'סיסמה חדשה',
      confirmNewPassword: 'אימות סיסמה חדשה',
      profileUpdated: 'הפרופיל עודכן בהצלחה',
      passwordChanged: 'הסיסמה שונתה בהצלחה',
      updateFailed: 'נכשל בעדכון הפרופיל',
      passwordChangeFailed: 'נכשל בשינוי הסיסמה',
      cannotChange: 'לא ניתן לשנות',
      clickToChangePassword: 'לחץ כדי לשנות את הסיסמה',
      deleteAccount: 'מחיקת חשבון',
      deleteAccountWarning: 'פעולה זו אינה הפיכה ותמחק לצמיתות את החשבון שלך ואת כל הרכישות הקודמות.',
      deleteAccountConfirm: 'האם אתה בטוח שברצונך למחוק את החשבון?',
      accountDeleted: 'החשבון נמחק בהצלחה',
      deleteAccountFailed: 'נכשל במחיקת החשבון'
    },
  common: {
    cancel: 'ביטול',
    save: 'שמירה',
    add: 'הוספה',
    yes: 'כן',
    no: 'לא',
    back: 'חזרה',
    home: 'בית'
  },
  myOrders: {
    title: 'הזמנות שלי',
    subtitle: 'צפה בכל הרכישות הקודמות שלך',
    notAuthenticated: 'אנא התחבר כדי לצפות בהזמנות שלך',
    loading: 'טוען את ההזמנות שלך...',
    empty: {
      title: 'אין הזמנות עדיין',
      description: 'עדיין לא ביצעת רכישות. גלה את האוסף המדהים שלנו של הדרכות, סדנאות ומוצרים דיגיטליים - המסע היצירתי שלך מתחיל כאן!'
    },
    table: {
      orderDate: 'תאריך הזמנה',
      productType: 'סוג מוצר',
      name: 'שם המוצר',
      amount: 'סכום',
      image: 'תמונה',
      action: 'פעולה'
    },
    productTypes: {
      tutorial: 'הדרכה',
      workshop: 'סדנה',
      item: 'פריט',
      file: 'קובץ'
    },
    actions: {
      download: 'הורד',
      open: 'פתח'
    },
    unknownProduct: 'מוצר לא ידוע'
  },
  admin: {
    tabs: {
      users: 'ניהול משתמשים',
      workshops: 'ניהול סדנאות',
      shop: 'ניהול חנות',
      tutorials: 'ניהול מדריכים',
      files: 'ניהול קבצים',
      bannerTexts: 'טקסטים מתחלפים',
      sendGift: 'שלח מתנה',
      orders: 'ניהול הזמנות',
      checkoutSessions: 'סשני תשלום',
      purchaseStats: 'סטטיסטיקות רכישות'
    },
    sorting: {
      sortBy: 'מיין לפי',
      order: 'סדר',
      ascending: 'עולה',
      descending: 'יורד',
      joinedDate: 'תאריך הצטרפות',
      lastLogin: 'התחברות אחרונה',
      firstName: 'שם פרטי',
      lastName: 'שם משפחה',
      email: 'אימייל',
      never: 'מעולם לא'
    },
    products: {
      addNew: 'הוסף מוצר חדש',
      edit: 'ערוך מוצר',
      confirmDelete: 'האם אתה בטוח שברצונך למחוק מוצר זה?',
      title: 'כותרת',
      description: 'תיאור',
      category: 'קטגוריה',
      price: 'מחיר',
      discount: 'הנחה (%)',
      inventory: 'מלאי',
      promoted: 'מומלץ',
      active: 'פעיל',
      actions: 'פעולות',
      priority: 'עדיפות',
      customizable: 'מותאם אישית',
      dragAndDropImage: 'גרור ושחרר תמונה ראשית לכאן',
      orClickToUploadImage: 'או לחץ כדי להעלות',
      selectedImage: 'תמונה ראשית שנבחרה',
      dragAndDropSecondaryImages: 'גרור ושחרר תמונות משניות לכאן',
      orClickToUploadSecondaryImages: 'או לחץ כדי להעלות',
      selectedSecondaryImages: 'תמונות משניות שנבחרו',
      atLeastOneImageRequired: 'נדרשת לפחות תמונה אחת',
      uploadFailed: 'העלאה נכשלה. אנא נסה שוב.',
      categories: {
        cricut: 'קריקט',
        goldsmith: 'צורפות',
        teva: 'מייקרים ויצירה מקיימת',
        modeling3d: '3D מידול',
        svgfiles: 'פריסות למיתוג וקבצי SVG',
        sublimation: 'סובלימציה',
        others: 'אחרים'
      }
    },
    files: {
      addNew: 'הוסף קובץ חדש',
      edit: 'ערוך קובץ',
      confirmDelete: 'האם אתה בטוח שברצונך למחוק קובץ זה?',
      title: 'כותרת',
      description: 'תיאור',
      category: 'קטגוריה',
      price: 'מחיר',
      discount: 'הנחה (%)',
      active: 'פעיל',
      promoted: 'מומלץ',
      actions: 'פעולות',
      priority: 'עדיפות',
      image: 'תמונה',
      downloadFile: 'קובץ להורדה',
      dragAndDropImage: 'גרור ושחרר תמונה לכאן',
      orClickToUploadImage: 'או לחץ כדי להעלות תמונה',
      selectedImage: 'התמונה שנבחרה',
      dragAndDropDownload: 'גרור ושחרר קובץ להורדה לכאן',
      orClickToUploadDownload: 'או לחץ כדי להעלות קובץ',
      selectedDownload: 'הקובץ שנבחר להורדה',
      uploadFailed: 'העלאה נכשלה. אנא נסה שוב.',
      categories: {
        cricut: 'קריקט',
        goldsmith: 'צורפות',
        teva: 'מייקרים ויצירה מקיימת',
        modeling3d: '3D מידול',
        svgfiles: 'פריסות למיתוג וקבצי SVG',
        sublimation: 'סובלימציה',
        others: 'אחרים'
      }
    },
    workshops: {
      addNew: 'הוסף סדנה חדשה',
      edit: 'ערוך סדנה',
      confirmDelete: 'האם אתה בטוח שברצונך למחוק סדנה זו?',
      title: 'כותרת',
      description: 'תיאור',
      location: 'מיקום',
      category: 'קטגוריה',
      level: 'רמה',
      price: 'מחיר',
      participants: 'משתתפים',
      actions: 'פעולות',
      participantLimit: 'מספר משתתפים מקסימלי',
      earlyBirdDate: 'תאריך הנחה מוקדמת',
      earlyBirdDiscount: 'הנחה מוקדמת (%)',
      image: 'כתובת תמונה',
      workshopDates: 'תאריכי הסדנה',
      date: 'תאריך',
      duration: 'משך (דקות)',
      addDate: 'הוסף תאריך נוסף',
      dragAndDrop: 'גרור ושחרר תמונה לכאן',
      orClickToUpload: 'או לחץ כדי לדפדף',
      selectedImage: 'כתובת התמונה שנבחרה',
      active: 'פעיל',
      priority: 'עדיפות',
      levels: {
        title: 'רמות',
        beginner: 'מתחילים',
        intermediate: 'בינוני',
        advanced: 'מתקדמים',
        all: 'כל הרמות'
      },
      categories: {
        cricut: 'קריקט',
        goldsmith: 'צורפות',
        teva: 'מייקרים ויצירה מקיימת',
        modeling3d: '3D מידול',
        svgfiles: 'פריסות למיתוג וקבצי SVG',
        sublimation: 'סובלימציה',
        others: 'אחרים'
      }
    },
    tutorials: {
      addNew: 'הוסף הדרכה חדשה',
      edit: 'ערוך הדרכה',
      confirmDelete: 'האם אתה בטוח שברצונך למחוק הדרכה זו?',
      title: 'כותרת',
      description: 'תיאור',
      category: 'קטגוריה',
      level: 'רמה',
      price: 'מחיר',
      discount: 'הנחה (%)',
      actions: 'פעולות',
      active: 'פעיל',
      priority: 'עדיפות',
      dragAndDropImage: 'גרור ושחרר תמונה לכאן',
      orClickToUploadImage: 'או לחץ כדי לדפדף',
      selectedImage: 'כתובת התמונה שנבחרה',
      dragAndDropContentImages: 'גרור ושחרר תמונות תוכן לכאן',
      orClickToUploadContentImages: 'או לחץ כדי לדפדף',
      selectedContentImages: 'תמונות התוכן שנבחרו',
      atLeastOneImageRequired: 'נדרשת לפחות תמונת תוכן אחת',
      uploadFailed: 'העלאה נכשלה. אנא נסה שוב.',
      levels: {
        title: 'רמות',
        beginner: 'מתחילים',
        medium: 'בינוני',
        advanced: 'מתקדמים'
      },
      categories: {
        cricut: 'קריקט',
        goldsmith: 'צורפות',
        others: 'אחרים',
        teva: 'מייקרים ויצירה מקיימת',
        modeling3d: '3D מידול',
        svgfiles: 'פריסות למיתוג וקבצי SVG',
        sublimation: 'סובלימציה'
      }
    },
    bannerTexts: {
      title: 'ניהול טקסטים מתחלפים',
      addNew: 'הוסף טקסט חדש',
      edit: 'ערוך טקסט מתחלף',
      text: 'טקסט',
      endDate: 'תאריך סיום',
      actions: 'פעולות',
      noEndDate: 'ללא תאריך סיום',
      confirmDelete: 'האם אתה בטוח שברצונך למחוק את הטקסט המתחלף הזה?',
      errors: {
        textRequired: 'נדרש להזין טקסט'
      }
    },
    sendGift: {
      title: 'שלח מתנה',
      selectUser: 'בחר משתמש',
      userSearchPlaceholder: 'חפש לפי שם או אימייל...',
      typeToSearch: 'הקלד לפחות 2 תווים לחיפוש',
      noUsersFound: 'לא נמצאו משתמשים',
      selectType: 'סוג מוצר',
      typeTutorial: 'מדריך',
      typeFile: 'קובץ SVG',
      selectItem: 'בחר פריט',
      sendButton: 'שלח מתנה',
      sending: 'שולח...',
      success: 'המתנה נשלחה בהצלחה!',
      errors: {
        missingFields: 'אנא בחר משתמש ופריט',
        userSearchFailed: 'חיפוש משתמשים נכשל',
        itemsFetchFailed: 'טעינת פריטים נכשלה',
        sendFailed: 'שליחת המתנה נכשלה'
      }
    },
    orders: {
      orderId: 'מזהה הזמנה',
      customer: 'לקוח',
      product: 'מוצר',
      productType: 'סוג',
      amount: 'סכום',
      status: 'סטטוס',
      date: 'תאריך',
      paymentId: 'מזהה תשלום',
      actions: 'פעולות',
      noOrders: 'לא נמצאו הזמנות',
      loading: 'טוען הזמנות...',
      error: 'שגיאה בטעינת הזמנות',
      completed: 'הושלם',
      preparing: 'בהכנה',
      refunded: 'הוחזר',
      cancelled: 'בוטל',
      updateStatus: 'עדכן סטטוס',
      viewAddress: 'צפייה בכתובת למשלוח',
      markCompleted: 'סמן כהושלם',
      shippingAddress: 'כתובת למשלוח',
      flat: 'דירה',
      phone: 'טלפון',
      markCompletedSuccess: 'ההזמנה סומנה כהושלמה',
      markCompletedError: 'שגיאה בעדכון סטטוס ההזמנה',
      selectStatus: 'בחר סטטוס',
      sortBy: 'מיין לפי',
      sortByTime: 'זמן',
      sortByAmount: 'סכום',
      sortByStatus: 'סטטוס',
      sortOrder: 'סדר מיון',
      ascending: 'עולה',
      descending: 'יורד',
      deletedUser: 'משתמש נמחק'
    },
    checkoutSessions: {
      sessionId: 'מזהה סשן',
      customer: 'לקוח',
      items: 'פריטים',
      totalPrice: 'סכום כולל',
      itemCount: 'מספר פריטים',
      createdAt: 'נוצר ב',
      updatedAt: 'עודכן ב',
      transactionId: 'מזהה עסקה',
      actions: 'פעולות',
      noSessions: 'לא נמצאו סשני תשלום',
      loading: 'טוען סשני תשלום...',
      error: 'שגיאה בטעינת סשני תשלום',
      sortBy: 'מיין לפי',
      sortByCreatedAt: 'תאריך יצירה',
      sortByUpdatedAt: 'תאריך עדכון',
      sortByTotalPrice: 'סכום כולל',
      sortByItemCount: 'מספר פריטים',
      sortOrder: 'סדר מיון',
      ascending: 'עולה',
      descending: 'יורד',
      minItems: 'מינימום פריטים',
      viewDetails: 'הצג פרטים',
      productType: 'סוג',
      deletedUser: 'משתמש נמחק',
      quantity: 'כמות',
      price: 'מחיר',
      shippingAddress: 'כתובת למשלוח',
      flat: 'דירה',
      phone: 'טלפון'
    },
    purchaseStats: {
      product: 'מוצר',
      productType: 'סוג',
      totalPurchases: 'סה"כ רכישות',
      totalRevenue: 'סה"כ הכנסות',
      averagePrice: 'מחיר ממוצע',
      lastPurchase: 'רכישה אחרונה',
      averageOrderValue: 'ערך הזמנה ממוצע',
      uniqueProducts: 'מוצרים ייחודיים',
      startDate: 'תאריך התחלה',
      endDate: 'תאריך סיום',
      loading: 'טוען סטטיסטיקות רכישות...',
      error: 'שגיאה בטעינת סטטיסטיקות רכישות',
      sortBy: 'מיין לפי',
      sortByPurchases: 'סה"כ רכישות',
      sortByRevenue: 'סה"כ הכנסות',
      sortByAveragePrice: 'מחיר ממוצע',
      sortByLastPurchase: 'תאריך רכישה אחרונה',
      sortByTitle: 'כותרת מוצר',
      sortOrder: 'סדר מיון',
      ascending: 'עולה',
      descending: 'יורד'
    }
  },
  passover: {
    newDesigns: '🎉 עיצובים חדשים לקראת פסח, הירשם עכשיו לקבל 10% הנחה לקנייה ראשונה'
  },
  pages: {
    about: {
      title: 'אודותיי - סדנאות קריקט ועיצוב דיגיטלי ',
      subtitle: 'אומנית, צורפת ומעצבת דיגיטלית - מומחית לקריקט ',
      mission: 'אני ענבל לוין, אומנית, צורפת ויוצרת מקצועית, שמחברת בין היופי הנצחי של המלאכה המסורתית לבין הפוטנציאל החדשני של עיצוב דיגיטלי מודרני. כמומחית לקריקט , העבודה שלי חוצה את הגבול בין יצירות ידניות לבין תחום העיצוב הדיגיטלי, שבו אני מיומנת גם בעיצוב דו-מימדי וגם בתלת-מימדי, כמו גם בהדפסה תלת-מימדית. השילוב הייחודי הזה מאפשר לי לחיות בשני העולמות – גם בעולם המלאכות היד המסורתיות וגם בעידן המהיר שבו כל דבר מתוכנן במחשב לפני שהוא מקבל חיים במציאות.',
      vision: 'בנוסף לפעילות האישית שלי כיוצרת, אני גם מתחייבת לשתף את הידע והכישורים שלי עם אחרים. אני מעבירה סדנאות קריקט מקצועיות לפיתוח חשיבה יצירתית, ומנחה ילדים ומבוגרים לחקור את הדמיון שלהם ולפתח את הכשרונות האמנותיים שלהם. הסדנאות כוללות מגוון נושאים כמו תכשיטנות, מקרמה וטבע עירוני, ומציעות למשתתפים הזדמנות להתחבר עם היצירתיות שלהם בדרכים משמעותיות.',
      values: 'בין אם באמצעות חוויות מעשיות או עיצוב דיגיטלי מתקדם, אני שואפת להשראה ולהעצים את האנשים להביע את עצמם דרך אומנות ומלאכה, ובכך לגשר בין מסורת לעתיד. כמומחית לקריקט , אני מביאה את הידע והניסיון שלי לכל סדנה והדרכה.',
      team: {
        title: 'הצוות שלנו',
        member1: {
          name: 'חבר צוות 1',
          role: 'תפקיד 1',
          bio: 'ביוגרפיה 1'
        },
        member2: {
          name: 'חבר צוות 2',
          role: 'תפקיד 2',
          bio: 'ביוגרפיה 2'
        },
        member3: {
          name: 'חבר צוות 3',
          role: 'תפקיד 3',
          bio: 'ביוגרפיה 3'
        }
      },
      contact: {
        title: 'צור קשר',
        description: 'צרו איתנו קשר לכל שאלה או פנייה.',
        email: 'אימייל'
      },
      name: 'ענבל לוין',
      workshops: {
        description: 'מעבירה סדנאות לפיתוח חשיבה יצירתית ומקיימת לילדים, וסדנאות תכשיטנות, מקרמה וטבע עירוני לילדים ומבוגרים.'
      }
    },
    contact: {
      title: "צור קשר",
      subtitle: "להדרכות, סדנאות והשראה - מוזמנים לעקוב ברשתות החברתיות. לפרטים על סדנאות והדרכות מוזמנים ליצור קשר",
      email: "שלח לי אימייל",
      form: {
        name: "שם מלא",
        email: "כתובת אימייל",
        subject: "נושא",
        message: "הודעה",
        submit: "שלח הודעה",
        successMessage: "תודה על ההודעה שלך! אחזור אליך בהקדם.",
        errorMessage: "אופס! משהו השתבש. אנא נסה שוב."
      },
      info: {
        title: "פרטי התקשרות",
        addressTitle: "כתובת",
        address: " הרצליה",
        phoneTitle: "טלפון",
        phone: "054-7798844",
        emailTitle: "אימייל",
        email: "inbal.artmakers@gmail.com"
      }
    },
    workshops: {
      title: 'סדנאות קריקט ועיצוב דיגיטלי ',
      subtitle: 'הצטרפו לסדנאות הקריקט המקצועיות שלנו  ושחררו את הפוטנציאל האמנותי שלכם',
      location: 'מיקום',
      level: 'רמה',
      price: 'מחיר',
      register: 'הירשמו עכשיו',
      loading: 'טוען סדנאות...',
      error: 'שגיאה בטעינת הסדנאות',
      dates: 'תאריכים',
      minutes: 'דקות',
      levels: {
        title: 'רמות',
        beginner: 'מתחילים',
        medium: 'בינוני',
        advanced: 'מתקדמים',
      },
      categories: {
        title: 'קטגוריות',
        painting: 'ציור',
        drawing: 'רישום',
        sculpture: 'פיסול',
        digital: 'אמנות דיגיטלית',
        mixed: 'מדיה מעורבת',
        photography: 'צילום',
        printmaking: 'הדפס',
        ceramics: 'קרמיקה',
        textiles: 'טקסטיל',
        jewelry: 'תכשיטנות',
        cricut: 'קריקט',
        goldsmith: 'צורפות',
        others: 'אחרים',
        teva: 'מייקרים ויצירה מקיימת',
        modeling3d: '3D מידול',
        svgfiles: 'פריסות למיתוג וקבצי SVG',
        sublimation: 'סובלימציה',
        other: 'אחר'
      }
    },
    tutorials: {
      title: 'הדרכות',
      subtitle: 'למדו כיצד ליצור תכשיטים יפים',
      loading: 'טוען הדרכות...',
      viewDetails: 'צפה בפרטים',
      openTutorial: 'פתח הדרכה',
      addToCheckout: 'הוסף לעגלה',
      addedToCheckout: 'ההדרכה נוספה לעגלה בהצלחה',
      errorLoading: 'שגיאה בטעינת ההדרכה',
      notFound: 'הדרכה לא נמצאה',
      openInNewTab: 'פתח הדרכה בחלון חדש',
      openInNewTabDescription: 'ההדרכה תיפתח בחלון חדש לחווית צפייה מיטבית.',
      filters: {
        sortBy: 'מיין לפי',
        difficulty: 'רמת קושי',
        duration: 'משך זמן'
      },
      categories: {
        all: 'כל הרמות',
        beginner: 'מתחילים',
        intermediate: 'בינוני',
        advanced: 'מתקדמים'
      },
      available: 'זמין',
      page: 'עמוד',
      of: 'מתוך'
    },
    shop: {
      title: 'חנות',
      subtitle: 'גלו את המוצרים הייחודיים שלנו',
      filters: {
        category: 'קטגוריה',
        sortBy: 'מיין לפי'
      },
      categories: {
        all: 'כל הקטגוריות'
      },
      sort: {
        newest: 'החדשים ביותר',
        priceLow: 'מחיר: מהנמוך לגבוה',
        priceHigh: 'מחיר: מהגבוה לנמוך'
      },
      addToCart: 'הוסף לעגלה'
    },
    category: {
      products: 'מוצרים',
      workshops: 'סדנאות',
      tutorials: 'מדריכים',
      files: 'קבצים להורדה',
      inCart: 'בעגלה',
      removeFromCart: 'הסר מהעגלה',
      downloadFile: 'הורד קובץ',
      productsDescription: 'גלו את אוסף המוצרים האיכותיים שלנו',
      workshopsDescription: 'מוזמנות להצטרף אליי למפגש צורפות קסום - לדמיין ולהגשים. ביחד נקבל השראה, נתכנן, נלמד על התהליכים האפשריים ליצירה וניצור תכשיט אישי בעבודת יד.',
      tutorialsDescription: `אני מאמינה שלמידה איכותית והטמעת הידע יכולה להתבצע רק ׳דרך הידיים׳ ולכן הגישה החינוכית שלי היא למידה באמצעות פרויקטים. 
       כל פרויקט מותאם לרמת הלימודים ומכיל אלמנטים רבים בתוכנה, שתוכלו לעשות בהם שימוש נרחב ומגוון, עד שתהפכו למקצוענים בחיתוך ובמיתוג. 
       בכל פרויקט יש מילון מושגים מקיף, סרטון הכנה ופרויקט פתוח בדיזיין ספייס בכדי שתוכלו לראות את התוצר המוגמר. 
       אני שמה דגש על פיתוח חשיבה יצירתית ועצמאית ומעניקה לכם את הכלים לכך.`,
      filesDescription: 'קבצי עיצוב דיגיטליים, תבניות וחומרים להורדה לשימוש ביצירות שלכם',
      cricut: {
        description: `בואו להכיר את קסם החיתוך הדיגיטלי.
מכשירי החיתוך הדיגיטלי הביאו מהפכה ביתית ליוצרות בנייר. 
בכלים פשוטים כל אחד יכול לעצב דיגיטלית ולהעביר את המוצרים לחיתוך בנוחות וקלות.
כמעצבת גרפית בעלת נסיון רב ועם תלמידים רבים שכבר מצליחים ועובדים בתחום, אני מנגישה לכם את עולם העיצוב הגרפי והמיתוג, גם לתלמידים שאינם בעלי נסיון גרפי כלל.
אני מלמדת בסטודיו שלי בהרצליה שיעורים פרטיים וקבוצתיים, מלמדת אתכם להתמקצע בחיתוך במכונה ומתאימה את הלימודים לתחום העסק שלכן.
אני בעלת תואר במנהל עסקים ובעלת נסיון בליווי עסקים בראשית דרכם ומעבר לידע הטכני והעיצובי, אני שמחה להעניק יעוץ לעסקים יצירתיים בכדי לקדם את עצמם ולבלוט מעל האחרים.
אני חלק מצוות שגרירות המותג cricut   ושמחה להעניק לכם מעטפת מלאה לרכישה, למידה והצלחה כתחביב או מקצוע.
מוזמנות להצטרף אליי לעולם הקסום של החיתוך הדיגיטלי ולתאם סדנא פורנטלית או בזום, או לרכוש את אחת ההדרכות הדיגיטליות.`
      },
      goldsmith: {
        description: `כשהייתי ילדה קטנה, עוד לפני שנבנו הקניונים, אמי הייתה לוקחת אותי איתה באופן קבוע לחנות התכשיטים הסמוכה לבית. 
נמכרו שם תכשיטי כסף בעבודת יד ובגב כל תכשיט הופיעה חתימת המעצב בכתב יד.
היכולת לקחת מקבץ רעיונות וחומרים ולהפוך אותם ליצירה אישית נראתה לי כמו קסם. כבר אז התחלתי ליצור תכשיטים מחימר פולימרי, מקרמה וחרוזים וחלמתי להיות צורפת. כשבגרתי, הגשמתי את החלום להתמחות בצורפות קלאסית ועד היום אני מתרגשת מהעבודה הקסומה. 
גם הטכנולוגיה התפתחה ולמדתי לעצב ולהדפיס תכשיטים באופן ממוחשב, אך אין תחליף בעיניי לעבודת היד ולמגע עם החומר. `
      },
      teva: {
        description: `סדנאות לפיתוח חשיבה יצירתית ומקיימת`
      },
      modeling3d: {
        description: `בהכשרתי אני ממדלת תכשיטים, מעצבת חלום במחשב ושולחת אותו הלאה. 
        מאז שמדפסות תלת המימד פרצו בנגישות לחיינו, התחלתי לעצב מוצרים ופתרונות יצירתיים ושימושיים. 
        אני משלבת את המידול גם בלימודי המייקרים ובסדנאות הילדים. 
        ?מחפשים פתרון מודפס בתלת מימד? צריכים מודל
        צרו קשר ונמדל לכם פתרון`
      },
      svgfiles: {
        description: `האהבה שלי לגרפיקה ממוחשבת התחילה בתיכון. למדנו למדוד, לעצב וכיצד יוצרים קבצים וקטורים.
        עברו מאז כמעט 25 שנה ומאז אני מקפידה להתעדכן בתוכנות ובקדמת הטכנולוגיה, שממשכימה להפתיע עם כלים חדשים בכל פעם. 
        אם בעבר היינו עובדים שעות בשביל להוריד דמות מתמונה או להוריד צל, היום הכל בלחיצת כםתור בעזרת הבינה המלאכותית.
        היכולות של התוכנות הגרפיות היום אינן דומות לאלו שהיו לפני 25 שנה וכאשר לומדים את התחום אסור לקפוא על השמרים, יש להמשיך ללמוד ולהתקדם עם הטכנולוגיה.
        אני יוצרת קבצים וקטורים בהתאמה אישית, פריסות, קבצי חיתוך, שבלונות ועוד מוצרים עונתיים וחגיגיים המתאימים לחיתוכי לייזר ולחיתוך דיגיטלי. 
        למוצרים מותאמים אישית צרו קשר.`
      },
      others: {
        description: `עברו על האוסף המגוון שלנו של חומרי יצירה וכלים`
      },
      sublimation: {
        description: `רוצים ללמוד את תחום הסובלימציה?
        רוצים לרכוש מתנות ממותגות?
        הגעתם למקום הנכון.ֿ
        בואו להפוך את התמונות, הציורים והרעיונות שלכם למוצרים ממותגים.
        מתאים ללקוחות פרטיים, לגני ילדים, מוסדות ועוד.ֿ`
      }
    },
    chat: {
      title: 'צ\'אט AI Cricut',
      description: 'קבלו עזרה מיידית לשאלות ה-Cricut שלכם מהיועץ הבינה המלאכותית שלנו. היסטוריית הצ\'אט נשמרת רק בדפדפן שלכם ומתנקה כשסוגרים את הלשונית.',
      welcome: 'ברוכים הבאים לצ\'אט AI Cricut!',
      welcomeSubtitle: 'שאלוני כל שאלה על מכונות Cricut, Design Space, חומרים או רעיונות לפרויקטים.',
      placeholder: 'הקלידו את השאלה שלכם כאן...',
      clear: 'נקה צ\'אט',
      error: 'שליחת ההודעה נכשלה. אנא נסו שוב.'
    },
    freeTools: {
      title: 'כלים חינמיים',
      description: 'גשו לכלים חינמיים שיעזרו לכם בפרויקטי Cricut. כל הכלים פועלים 100% בדפדפן שלכם - לא נשלח שום נתון לשרתים שלנו.',
      tabs: {
        imageToSVG: 'תמונה לדף צביעה',
        promptToImage: 'טקסט לתמונה (Cricut)',
        promptToImageUnfiltered: 'טקסט לתמונה (מלא)'
      },
      imageToSVG: {
        title: 'תמונה לדף צביעה',
        description: 'המירו תמונות לקווי מתאר SVG לשימוש ב-Cricut Design Space. העלו תמונה, כוונו את הסף והחדות, והורידו את קובץ ה-SVG.\nחשוב לדעת: התמונה לא נשמרת בשום מקום וכל קסם מתבצע בדפדפן שלכם.',
        uploadImage: 'העלה תמונה',
        processing: 'מעבד...',
        original: 'תמונה מקורית',
        processed: 'תמונה מעובדת',
        threshold: 'סף (שחור/לבן)',
        sharpness: 'חדות (יחס קווי מתאר)',
        svgOutput: 'פלט SVG',
        download: 'הורד SVG',
        downloadSvg: 'הורד SVG',
        downloadPng: 'הורד PNG',
        errors: {
          invalidFile: 'אנא העלו קובץ תמונה תקין.',
          loadFailed: 'טעינת התמונה נכשלה.',
          readFailed: 'קריאת הקובץ נכשלה.',
          canvasContext: 'אתחול canvas נכשל.',
          processingFailed: 'עיבוד התמונה נכשל. אנא נסו שוב.',
          loginRequired: 'אנא התחברו כדי להשתמש בכלי זה. מפנה לעמוד ההתחברות...'
        }
      },
      promptToImage: {
        title: 'הכנת קובץ חיתוך לקריקאט',
        description: 'צרו קבצי חיתוך מוכנים ל-Cricut מתיאורי טקסט. כתבו תיאור קצר בעברית של האובייקט שאתם רוצים לחתוך, והבינה המלאכותית שלנו תיצור קובץ קווי מתאר בשחור-לבן מושלם לחיתוך במכונת הקריקאט.',
        promptPlaceholder: 'הכניסו תיאור בעברית (למשל: "כלב", "פרח", "לב")',
        negativePromptPlaceholder: 'פרומפט שלילי (אופציונלי) - דברים להימנע מהם בעברית',
        generateButton: 'צור קובץ חיתוך',
        generating: 'יוצר קובץ חיתוך...',
        downloadSvg: 'הורד SVG',
        downloadPng: 'הורד PNG',
        errors: {
          emptyPrompt: 'אנא הכניסו תיאור',
          loginRequired: 'אנא התחברו כדי להשתמש בכלי זה. מפנה לעמוד ההתחברות...',
          generationFailed: 'יצירת קובץ החיתוך נכשלה. אנא נסו שוב.',
          downloadFailed: 'הורדת קובץ החיתוך נכשלה. אנא נסו שוב.'
        },
        success: 'קובץ החיתוך נוצר בהצלחה!'
      },
      promptToImageUnfiltered: {
        title: 'מחולל תמונות AI (פרומפט מלא)',
        description: 'צרו תמונות מתיאורי טקסט עם שליטה מלאה. כתבו תיאור בעברית, והבינה המלאכותית שלנו תתרגם אותו לאנגלית ותיצור תמונה בדיוק כפי שתיארתם. כל הסגנון, הצבעים והפרטים מהפרומפט שלכם יישמרו.',
        promptPlaceholder: 'הכניסו תיאור בעברית (למשל: "כלב חום יושב בפארק", "פרח אדום גדול")',
        negativePromptPlaceholder: 'פרומפט שלילי (אופציונלי) - דברים להימנע מהם בעברית',
        generateButton: 'צור תמונה',
        generating: 'יוצר תמונה...',
        downloadSvg: 'הורד SVG',
        downloadPng: 'הורד PNG',
        errors: {
          emptyPrompt: 'אנא הכניסו תיאור',
          loginRequired: 'אנא התחברו כדי להשתמש בכלי זה. מפנה לעמוד ההתחברות...',
          generationFailed: 'יצירת התמונה נכשלה. אנא נסו שוב.',
          downloadFailed: 'הורדת התמונה נכשלה. אנא נסו שוב.'
        },
        success: 'התמונה נוצרה בהצלחה!',
        styling: {
          title: 'אפשרויות עיצוב (אופציונלי)',
          style: 'סגנון',
          effectColor: 'אפקט - צבע',
          effectLightning: 'אפקט - תאורה',
          effectFraming: 'אפקט - מסגור',
          colors: 'צבעים דומיננטיים',
          colorWeight: 'משקל (0.05-1)',
          none: 'ללא'
        }
      }
    }
  },
  checkout: {
    title: 'עגלת קניות',
    empty: 'העגלה שלך ריקה',
    emptySubtitle: 'נראה שעדיין לא הוספת פריטים לעגלה!',
    continueShopping: 'המשך בקניות',
    total: 'סה״כ',
    clear: 'נקה עגלה',
    proceed: 'המשך לתשלום',
    processing: 'מעבד...',
    currency: '₪',
    productType: {
      tutorial: 'הדרכה',
      workshop: 'סדנה',
      item: 'מוצר',
      file: 'קובץ דיגיטלי'
    },
    type: 'סוג',
    image: 'תמונה',
    productTitle: 'מוצר',
    price: 'מחיר',
    quantity: 'כמות',
    actions: 'פעולות',
    clearConfirmation: {
      title: 'ניקוי עגלה',
      message: 'האם אתה בטוח שברצונך לנקות את העגלה? פעולה זו אינה ניתנת לביטול.',
      cancel: 'ביטול',
      confirm: 'נקה עגלה'
    },
    terms: {
      accept: 'קראתי ומאשר את',
      view: 'תנאי השימוש והתקנון'
    },
    shipping: {
      title: 'כתובת למשלוח',
      subtitle: 'נדרש עבור מוצרים פיזיים בעגלה.',
      fullName: 'שם מלא של הנמען',
      city: 'עיר',
      street: 'רחוב',
      streetNumber: 'מספר בית',
      flat: 'דירה',
      notes: 'הערות לכתובת',
      phone: 'מספר טלפון',
      required: 'שדה חובה',
      selectCityFirst: 'בחרו עיר תחילה',
      noStreets: 'לא נמצאו רחובות',
      confirm: {
        title: 'אישור כתובת למשלוח',
        message: 'אנא ודאו שפרטי המשלוח נכונים לפני המשך לתשלום.',
        confirm: 'אישור, המשך',
        cancel: 'ביטול'
      }
    }
  },
  payment: {
    processing: {
      title: 'מעבד את התשלום שלך...',
      details: 'אנא המתן בזמן שאנו יוצרים את ההזמנות שלך ומעבדים את התשלום. זה עלול לקחת כמה רגעים.',
      creatingOrders: 'יוצר את ההזמנות שלך...',
      completed: 'העיבוד הושלם'
    },
    success: {
      title: 'התשלום בוצע בהצלחה!',
      message: 'תודה על הרכישה. התשלום שלך עובד בהצלחה.',
      details: 'תקבל אישור במייל בקרוב עם פרטי הרכישה.',
      continueShopping: 'המשך בקניות',
      viewOrders: 'צפה בהזמנות שלי'
    },
    failure: {
      title: 'התשלום נכשל',
      message: 'לצערנו, התשלום שלך לא הצליח להתבצע. זה יכול להיות בגלל מחסור בכספים, כרטיס שפג תוקפו, או תקלה טכנית.',
      details: 'אנא בדוק את פרטי התשלום ונסה שוב, או צור קשר עם צוות התמיכה שלנו אם הבעיה נמשכת.',
      tryAgain: 'נסה שוב',
      backToHome: 'חזור לעמוד הבית'
    }
  },
    homepage: {
    hero: {
      title: 'סדנאות קריקט מקצועיות  - אומנות פוגשת חדשנות',
      subtitle: 'גלו את השילוב המושלם בין מלאכת יד מסורתית לעיצוב דיגיטלי מודרני עם מומחית הקריקט ענבל לוין',
      cta: 'התחילו את המסע היצירתי שלכם'
    },
    about: {
      subtitle: 'צורפת, גרפיקאית, אומנית ויוצרת - מומחית לקריקט ',
      description: 'עוסקת במלאכות יד וכן מעצבת דיגיטלית (דו ותלת מימד), כך שאני חיה את עבודות היד \'של פעם\' וגם בקיאה בעולם העתידי בו הכל מתוכנן במחשב ומודפס. כמומחית לקריקט , אני מביאה את הידע והניסיון שלי לכל סדנה והדרכה.',
      workshops: {
        title: 'סדנאות קריקט ועיצוב דיגיטלי',
        description: 'מעבירה סדנאות קריקט מקצועיות לפיתוח חשיבה יצירתית ומקיימת לילדים, סדנאות תכשיטנות, מקרמה וטבע עירוני לילדים ומבוגרים. מלמדת כיצד לעבוד עם מכונות חיתוך דיגיטליות, למתג ולפתח חשיבה יצירתית עצמאית, שאינה תלויה רק בפרויקטים מוכנים. יוצרת מוצרים מותאמים אישית, כאלו שלא תראו בשום מקום אחר. מעניקה פתרונות יצירתיים לחלומות שלכם'
      }
    },
    featured: {
      title: 'גלו את השילוב המושלם בין מלאכת יד מסורתית לעיצוב מודרני',
      subtitle: 'מהדרכות עיצוב דיגיטלי ועד סדנאות מעשיות ועוד..',
      tutorials: {
        title: 'הדרכות עיצוב דיגיטלי',
        description: 'שלטו באמנות העיצוב הדיגיטלי עם ההדרכות המקיפות שלנו. מתאים למתחילים ולמתקדמים כאחד.',
        cta: 'עיון בהדרכות'
      },
      workshops: {
        title: 'סדנאות מעשיות',
        description: 'הצטרפו לסדנאות המרתקות שלנו והביאו את הרעיונות היצירתיים שלכם לחיים. למדו מאומנים מומחים בסביבה תומכת.',
        cta: 'צפייה בסדנאות'
      },
      shop: {
        title: 'יצירות ייחודיות',
        description: 'גלו את אוסף התכשיטים ופריטי האמנות המעוצבים ביד שלנו. כל פריט מספר את הסיפור שלו.',
        cta: 'קנייה עכשיו'
      }
    },
    cta: {
      title: 'מוכנים לשחרר את היצירתיות שלכם?',
      description: 'הצטרפו לקהילת היוצרים שלנו והתחילו את המסע היצירתי שלכם היום. בין אם אתם מתחילים או אמנים מנוסים, יש לנו משהו לכולם.',
      button: 'התחילו עכשיו'
    },
    inspiring: {
      title: 'בואו להפוך רעיונות ליצירה',
      subtitle: 'נגשים יחד את החזון היצירתי שלכם – בעזרת הדרכה מקצועית, כלים חדשניים וליווי אישי מהסקיצה ועד התוצאה המושלמת.'
    }
  },
  search: {
    resultsFor: 'תוצאות חיפוש עבור',
    resultsFound: 'תוצאות נמצאו',
    noResults: 'לא נמצאו תוצאות',
    tryDifferentKeywords: 'נסו מילות מפתח אחרות או בדקו את הכתיב',
    backToHome: 'חזרה לעמוד הבית',
    types: {
      tutorial: 'מדריך',
      file: 'קובץ SVG',
      product: 'מוצר',
      workshop: 'סדנה'
    }
  },
  deals: {
    title: 'קישורי קנייה מומלצים',
    subtitle: 'גלו את הכלים והמוצרים שאני משתמשת ביצירה שלי',
    noDeals: 'אין הצעות זמינות כרגע. בדקו שוב בקרוב!',
    loading: 'טוען הצעות...',
    viewOnAmazon: 'צפה באמזון',
    price: 'מחיר',
    asOf: 'מחיר נכון ל',
    disclosure: 'הצהרה',
    disclosureText: 'כשותף של אמזון, אני מרוויחה מקניות מתאימות. מחירי המוצרים הם תמונות מצב שנלקחו בזמן שגילינו אותם ועלולים להשתנות. כאשר תלחצו על קישור מוצר ותבצעו רכישה, אקבל עמלה קטנה ללא עלות נוספת עבורכם.',
    priceNote: 'מחירי המוצרים וזמינותם מדויקים נכון לתאריך/שעה המצוינים וכפופים לשינויים. כל מידע על מחיר וזמינות שיוצג באמזון.com בעת הרכישה יחול על רכישת מוצר זה.',
    amazonNote: 'כל קישורי המוצרים בדף זה הם קישורי שותפים של אמזון.',
    importantNote: 'חלק מהמוצרים נבחרו ידנית על ידי, ואחרים נתגלו אוטומטית. אנא ודאו את המחיר הנוכחי באמזון, והכי חשוב - ודאו שהמוצרים זכאים למשלוח חינם על הזמנות מעל 49 דולר לפני הרכישה.'
  }
}; 